<script setup lang="ts">
withDefaults(
  defineProps<{
    /** What variant of the banner should be used? */
    variant?: keyof typeof variantMapping
    /** Optional accessible label for the banner region */
    ariaLabel?: string
  }>(),
  {
    variant: 'static'
  }
)

const variantMapping = {
  static: 'top-[72px] right-[10px]',
  staticFull: 'top-[72px] right-[10px]',
  flash: 'bottom-[240px] right-[10px] sm:bottom-auto',
  flashHome: 'top-[72px] right-[10px]'
}
</script>

<template>
  <div
    class="absolute left-[10px] sm:top-[72px] sm:left-0 sm:right-0 pointer-events-none"
    :class="variantMapping[variant]"
    :style="{
      zIndex: variant === 'flash' ? 100 : 20
    }"
    :aria-label="ariaLabel"
    aria-live="assertive"
    aria-atomic="true"
  >
    <slot></slot>
  </div>
</template>
